import { useState } from "react";
import InputMascarado from "../formulario/input-mascarado/InputMascarado";
import { mascaraCnpj } from "../../utils/mascaras";
import { UseFormReturn } from "react-hook-form";
import { brasilApiService } from "../../services/api/brasil-api/brasilapi";

export interface ICnpjData {
  cnpj?: string;
  fantasia?: string;
  razaoSocial?: string;
  nomeFantasia?: string;
}

type BuscarCNPJProps = {
  onResultado?: (data: ICnpjData) => void;
  methods: UseFormReturn<any>;
};

export function BuscarCNPJ({ onResultado, methods }: BuscarCNPJProps) {
  const [erro, setErro] = useState("");

  const buscar = async () => {
    const cnpj = methods.getValues("cnpj");
    if (cnpj) {
      try {
        setErro("");
        const response = await brasilApiService.getCnpj(
          cnpj.replace(/\D/g, "")
        );
        const data = response.data;
        const retorno = {
          razaoSocial: data.razao_social,
          cep: data.cep,
          cnpj: data.cnpj,
          bairro: data.bairro,
          uf: data.uf,
          cidade: data.municipio,
          nomeFantasia: data.nome_fantasia,
          rua: data.logradouro,
        };
        if (onResultado) {
          onResultado(retorno);
        }
      } catch (error) {
        setErro("CNPJ inválido ou não encontrado.");
        console.error(error);
        if (onResultado) onResultado({ cnpj });
      }
    }
  };

  return (
    <InputMascarado
      onBlur={buscar}
      name="cnpj"
      methods={methods}
      label="Digite o CNPJ"
      mask={mascaraCnpj}
      helperText={erro}
      error={!!erro}
    />
  );
}
